import {TimeUtil} from './time.util';

export const NPA_DATE_FORMATS = {
    parse: {
        dateInput: 'Y-MM-DD',
    },
    display: {
        dateInput: 'Y-MM-DD',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};


export class DateUtil {
    private $date: Date;

    constructor(dateString?: string | any) {
        const timeUtility = TimeUtil.getInstance();
        const tzOffset = timeUtility.getTimezoneOffset();
        this.date = new Date(dateString ? dateString : timeUtility.getSystemTime() * 1000);
        const ms0 = this.date.getMilliseconds();
        this.date.setMilliseconds(ms0 + tzOffset);
    }

    /**
     * @description Returns the underlying date object
     */
    get value() {
        return this.$date;
    }

    get date() {
        return this.$date;
    }

    set date(date: Date) {
        this.$date = date;
    }

    /**
     * @description Returns the current date and time based on the time on the server
     */
    static now(): Date {
        const timeUtility = TimeUtil.getInstance();
        return new Date(
            timeUtility.getSystemTime() * 1000 +
            timeUtility.getTimezoneOffset() +
            timeUtility.elapsedSystemTimeMs()
        );
    }

    /**
     * @param date The date object to convert
     * @description Converts a given date generated on the client machine with the machine timezone to its equivalent in the system timezone
     */
    static convert(date: Date) {
        const timeUtility = TimeUtil.getInstance();
        const tzOffset = timeUtility.getTimezoneOffset();
        const ms0 = date.getMilliseconds();
        date.setMilliseconds(ms0 + tzOffset);
        return date;
    }
}
